url = require('url')

module.exports = {
  getIdsAsList: (data, key) ->
    return [].concat.apply([], w[key] for w in data)

  get_from_list: (list, id, default_to_first = true) ->
    if not id
      return if default_to_first then list[0] else list[list.length - 1]
    for obj in list
      if obj.id == parseInt(id)
        return obj
    return null

  get_from_dict: (dict, id, default_to_first = true) ->
    ids = Object.keys(dict)
    if not id
      return if default_to_first then dict[ids[0]] else dict[ids[ids.length - 1]]
    for current_id in ids
      if parseInt(current_id) == id
        return dict[id]
    return null

  partitionAndSort: (data, partitionKey, sortKey) ->
    _get_value = (obj, key) ->
      keys = key.split('.')
      for k in keys
        if obj and k of obj
          obj = obj[k]
      return obj

    dataByKey = {}
    for d in data
      val = _get_value(d, partitionKey)
      if val not of dataByKey
        dataByKey[val] = []
      dataByKey[val].push(d)

    for dPartKey, list of dataByKey
      list.sort (a, b) ->
        val_a = _get_value(a, sortKey)
        val_b = _get_value(b, sortKey)
        if val_a > val_b
          return 1
        else if val_a == val_b
          return 0
        else
          return -1
        return val_a > val_b

    return dataByKey

  sort: (list, key, ascending = true) ->
    list.sort (a, b) ->
      if ascending
        return a[key] - b[key]
      else
        return b[key] - a[key]
    return list

  step_counter: (workflows, steps) ->
    wrkfls = {}
    for wrkfl in workflows
      wrkfls[wrkfl.id] = wrkfl
    project_stats = {}
    for step in steps
      project = wrkfls[step.workflow].project
      if project not of project_stats
        project_stats[project] = {'step_count': 0, 'complete_step_count': 0}
      project_stats[project]['step_count'] += 1
      if step.complete
        project_stats[project]['complete_step_count'] += 1
    return project_stats

  getHostname: (urlStr) ->
    if typeof urlStr is 'string' and hostname = url.parse(urlStr).hostname
      return hostname
    return ""

  dispatchResizeEvent: () ->
    if typeof(Event) == 'function'
      window.dispatchEvent(new Event('resize'))
    else
      evt = document.createEvent('UIEvents')
      evt.initUIEvent('resize', true, false, window, 0)
      window.dispatchEvent(evt)
}
